import { EXCHANGE_BRAND_ENTITY_TYPES, EXCHANGE_BRAND_USER_TYPES, PermissionRules, ROLES } from '@teamworksdev/influencer/core';

const isAgent = PermissionRules.hasRole(ROLES.AGENT);
const isTeamUser = PermissionRules.hasRole(ROLES.TEAM_USER);
const isComplianceOfficer = PermissionRules.hasRole(ROLES.COMPLIANCE_OFFICER);
const isBrandUser = PermissionRules.hasRole(ROLES.BRAND_USER);
const isBrandBusiness = PermissionRules.isBrandEntityType(EXCHANGE_BRAND_ENTITY_TYPES.BUSINESS);
const isBrandAdmin = PermissionRules.isBrandUserType(EXCHANGE_BRAND_USER_TYPES.EXCHANGE_ADMIN);

export {
	isAgent,
	isBrandUser,
	isBrandBusiness,
	isComplianceOfficer,
	isTeamUser,
	isBrandAdmin,
};
